// extracted by mini-css-extract-plugin
export var content = "_9j-3";
export var list = "_9j-4";
export var settingsContent = "_9j-7";
export var settingsPanel = "_9j-8";
export var state = "_9j-6";
export var triggerBadge = "_9j-2";
export var triggerButton = "_9j-1";
export var triggerShell = "_9j-0";
export var unreadDot = "_9j-5";